<template>
  <div>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-light hemolife-topnav">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="pushmenu"
            data-auto-collapse-size="991.98"
            aria-label="Abrir o cerrar menú"
            aria-controls="hemolife-main-menu"
            aria-expanded="false"
            href="#"
            role="button"
            ><i class="fas fa-bars"></i
          ></a>
        </li>
        <li class="nav-item hemolife-brand d-flex align-items-center py-0">
          <a href="/" class="d-flex align-items-center">
            <h1 class="mb-0 platform-title">Hemotrack</h1>
          </a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="/" class="nav-link font-weight-bold text-white">Inicio</a>
        </li>
      </ul>
      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="fas fa-th-large text-white"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-xl dropdown-menu-right hemolife-user-dropdown"
          >
            <!-- <span class="dropdown-item dropdown-header">15 Notifications</span> -->
            <div class="card card-widget widget-user-2 p-0 m-1 hemolife-user-card">
              <div
                class="widget-user-header bg-hemolife-blue mr-0 hemolife-user-header"
              >
                <h4 class="text-white hemolife-user-name mb-0">
                  <b>{{ this.$store.state.user.name }}</b>
                </h4>
                <hr class="hemolife-user-divider" />
                <!-- <h5 class="text-white" style="display: inline">
                  <b>Cargo:</b>
                </h5>
                <h6 class="text-white" style="display: inline">
                  {{ this.$store.state.user.charge }}
                </h6>
                <h5
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  <b>Empresa:</b>
                </h5>
                <h6
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  {{ this.$store.state.user.empresas[0].razon_social }}
                </h6> -->
                <!-- <br /> -->
                <div class="hemolife-user-meta">
                  <div class="hemolife-user-meta-row">
                    <span class="hemolife-user-label">Correo</span>
                    <span class="hemolife-user-value">{{
                      this.$store.state.user.email
                    }}</span>
                  </div>
                  <div class="hemolife-user-meta-row">
                    <span class="hemolife-user-label">N. Documento</span>
                    <span class="hemolife-user-value">{{
                      this.$store.state.user.n_document
                    }}</span>
                  </div>
                  <div class="hemolife-user-meta-row">
                    <span class="hemolife-user-label">Celular</span>
                    <span class="hemolife-user-value">{{
                      this.$store.state.user.cel
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="card-footer hemolife-user-footer">
                <ul class="nav flex-column hemolife-user-actions">
                  <li class="nav-item">
                    <router-link
                      to="/PerfilUsuario"
                      class="nav-link hemolife-user-action"
                    >
                      <i class="fa fa-user fa-fw mr-2"></i> Perfil
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <a
                      href="#"
                      class="nav-link hemolife-user-action"
                      data-toggle="modal"
                      data-target="#modal-actualizar-clave"
                    >
                      <i class="fa fa-lock fa-fw mr-2"></i> Cambiar clave
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="#"
                      @click.prevent="logout"
                      class="nav-link hemolife-user-action hemolife-user-logout"
                    >
                      <i class="fa fa-power-off fa-fw mr-2"></i> Salir
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
    <UpdatePassword></UpdatePassword>
  </div>
</template>
<script>
import UpdatePassword from "../UpdatePassword";

export default {
  name: "NavBarTop",
  components: {
    UpdatePassword,
  },
  data() {
    return {
      checkDarkMode: false,
    };
  },

  methods: {
    async logout() {
      await this.$store.dispatch("logout");

      // Recarga completa en vez de router.push: las rutas de los modulos se
      // registran en caliente con addRoutes y vue-router 3 no permite quitarlas,
      // asi que solo un arranque limpio deja la sesion siguiente sin residuos.
      // Ademas la ruta del login es /LoginForm; /login no existe en el router.
      window.location.replace("/LoginForm");
    },
  },
  mounted() {},
};
</script>

<style>
@media (max-width: 767.98px) {
  .left {
    width: 230px;
  }

  .texto {
    font-size: 0.7em;
  }

  .hemolife-topnav .platform-title {
    font-size: 13px;
    letter-spacing: 1.5px;
  }
}

/* Barra superior: gradiente marca + título con el mismo gradiente que el login */
.hemolife-topnav.main-header {
  background: linear-gradient(105deg, #4e6990 0%, #3d5f82 48%, #b82e31 100%);
  border: none;
  box-shadow: 0 2px 14px rgba(15, 23, 42, 0.14);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 3.1rem;
  padding-top: 0;
  padding-bottom: 0;
}

.hemolife-topnav .navbar-nav {
  align-items: center;
}

.hemolife-topnav .navbar-nav.ml-auto {
  align-items: center;
}

.hemolife-topnav .navbar-nav .nav-link {
  border-radius: 6px;
  transition: background 0.15s ease;
  display: flex;
  align-items: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.hemolife-topnav .navbar-nav .nav-link:hover {
  background: rgba(255, 255, 255, 0.12);
}

.hemolife-topnav .hemolife-brand {
  margin-right: 0.35rem;
}

/* Coral → turquesa: buen contraste sobre la barra oscura (como lo tenías antes) */
.hemolife-topnav .platform-title {
  font-size: 15px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  margin: 0;
  padding: 0 10px 0 0;
  line-height: 1;
  display: inline-block;
  font-family: "Roboto", sans-serif;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.35));
}

/* Menú de usuario (icono cuadrícula) */
.hemolife-user-dropdown {
  border: none;
  border-radius: 14px;
  padding: 0.35rem;
  min-width: 300px;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.22);
}

.hemolife-user-card {
  border: none !important;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: none !important;
  margin: 0 !important;
}

.hemolife-user-header {
  padding: 1rem 1.15rem 1.05rem !important;
  background: linear-gradient(145deg, #3d5f82 0%, #2c4766 50%, #4e6990 100%) !important;
  border: none !important;
}

.hemolife-user-name {
  font-size: 1.1rem;
  letter-spacing: 0.02em;
}

.hemolife-user-divider {
  border: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.5),
    transparent
  );
  margin: 0.8rem 0 0.65rem;
}

.hemolife-user-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hemolife-user-meta-row {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  line-height: 1.35;
}

.hemolife-user-label {
  color: rgba(255, 255, 255, 0.72);
  font-weight: 600;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.hemolife-user-value {
  color: #fff;
  font-size: 0.88rem;
  word-break: break-word;
  font-weight: 500;
}

.hemolife-user-footer {
  padding: 0.25rem 0 !important;
  background: #f8fafc !important;
  border-top: 1px solid #e2e8f0 !important;
}

.hemolife-user-actions .nav-item {
  margin: 0;
}

.hemolife-user-action {
  border-radius: 0;
  padding: 0.62rem 1rem !important;
  color: #334155 !important;
  display: flex;
  align-items: center;
  border-left: 3px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.hemolife-user-action:hover {
  background: rgba(78, 105, 144, 0.09) !important;
  border-left-color: #4e6990;
  color: #0f172a !important;
}

/* router-link se renderiza como <a>: mismas reglas que los demás ítems */
.hemolife-user-actions a.nav-link.hemolife-user-action {
  text-decoration: none !important;
}

.hemolife-user-logout:hover {
  background: rgba(229, 53, 56, 0.09) !important;
  border-left-color: #e53538;
  color: #b91c1c !important;
}
</style>
